<!--TODOS: Needs validation box? -->
<template>
  <li class="owc-header-navigation-link" role="none">
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <a
      v-if="navigationLink"
      class="owc-header-navigation-link__anchor"
      :href="navigationLink.url"
      :target="navigationLink.target"
      :aria-label="navigationLink.ariaLabel"
      @click="handleLinkClick"
      data-track="false"
      role="menuitem"
    >
      <p>{{ navigationLink.label }}</p>
      <p v-if="legalInfo" class="owc-header-navigation-link__legalText" v-html="legalInfo"></p>
    </a>
  </li>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { FlyoutLevels } from '@owc-packages/Header/src/Header.enums';
import { HeaderNavigationLinkComponent } from '@owc-packages/Header/src/HeaderNavigationLink';
import headerMixin from '@owc-utils/Mixins/Header';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as HeaderNavigationLinkComponent).extend({
  name: 'owc-header-navigation-link',
  mixins: [headerMixin, OwcDataComponent],
  components: {
    ValidationBoxWrapper,
  },
  computed: {
    navigationLink() {
      return this.componentData?.link;
    },
    legalInfo() {
      return this.componentData?.legalText;
    },
    currentFlyoutLevel() {
      if (this.componentData?.currentFlyoutLevel) {
        return this.componentData?.currentFlyoutLevel;
      }

      return FlyoutLevels.FLYOUT_LEVEL_ONE;
    },
    nextFlyoutLevel() {
      if (this.currentFlyoutLevel) {
        return this.currentFlyoutLevel + 1;
      }

      return FlyoutLevels.FLYOUT_LEVEL_THIRD;
    },
  },
  methods: {
    handleLinkClick(e: Event) {
      if (this.navigationLink) {
        const { url, label } = this.navigationLink;

        this.addAndSubmitTrackingTree(
          {
            label,
            url,
          },
          this.nextFlyoutLevel,
        );

        if (url && url.includes('#')) {
          e.preventDefault();
          this.closeHeaderFlyout(true);
          window.location.href = url;
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@owc-styles/utils';
@import './styles/flyout-vars';

.owc-header-navigation-link {
  @include breakpoint-to(mq4) {
    @include wb-content-width;
  }

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  //height is not enough since links can have legal text beneath them
  min-height: 64px - $flyout-spacing-extra-small;

  margin-bottom: $flyout-spacing-extra-small;

  text-align: left;
  overflow-wrap: break-word;

  list-style-type: none;

  @include breakpoint-from(mq5) {
    min-height: 40px;

    padding: 0;
  }

  &__legalText {
    @include wb-type-hint;

    color: var(--wb-grey-60);
  }
  &__anchor {
    @include wb-type-copy;

    width: 100%;

    color: var(--wb-grey-20);

    text-decoration: none;
  }
}

@include rtl-rule('.owc-header-navigation-link__anchor', false) {
  text-align: right;
}
</style>
